import React, { Component } from 'react';
import './../css/master.css';
import './../css/maintainBuyers.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
var httpURL = '';
var queryString = require('querystring');
var lstCompany =[];
var lstBuyers =[];
var lstBuyerType =[];
var lstCity =[];
var buyerIdCol 		= 'td:eq(0)';
var buyerNameCol 	= 'td:eq(1)';
var buyerEmailCol 	= 'td:eq(2)';
var buyerBlockedCol = 'td:eq(3)';

class MaintainBuyers extends Component {
  constructor(props){
	super(props);
	this.state={
		company:[],
		buyers:[],
		buyerType:[],
		city:[],
		flg:true,
		loader:'none',
		opacity:1,
		width:'97%',
	}
  }
  
  async componentDidMount(){
		this.setState({loader:'block', opacity:0.5});
	  await axiosInstance.get(httpURL+'/a/mst/pco/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					company:response.data.lstParentComp,
				})
				lstCompany = this.state.company;
				this.fillCompanyCmb();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  });
	  
	  await axiosInstance.get(httpURL+'/a/mst/cty/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					city:response.data.lstCity,
				})
				lstCity = this.state.city;
				this.fillCityCmb();
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  });
	  
	  this.handleResize();
		window.addEventListener("load", this.handleResize);
	  window.addEventListener("resize", this.handleResize);
  }
  
  handleResize=()=>{
	  var width = ($('.tableLayout1').parent().width())-18;
	  this.setState({width:width})
  }
  
  fillCompanyCmb(){
		$('#companyCmb').empty();
		$('#companyCmb').prepend($("<option> </option>").val(0).html('Company'));
		for(var i=0; i<lstCompany.length; i++){
			var companyId = lstCompany[i].parentCompId;
			var company	  = lstCompany[i].parentComp;
			$('#companyCmb').append($("<option> </option>").val(companyId).html(company));
		}
  }
  
  /*setBuyerTypeTable=(buyerType)=>{
	$('#buyerTypeTableBody tr').remove();
	var table = document.getElementById('buyerTypeTable');
	var tbody = document.getElementById('buyerTypeTableBody');
	 
	for(var i=0; i<buyerType.length; i++){
		var buyerTypeId = buyerType[i].buyerTypeId;
		var buyerType 	= buyerType[i].buyerType;
		var selected 	= buyerType[i].selected;
		
		var row = document.createElement('tr');
		row.id = buyerTypeId;
		    
		this.addTD(row, buyerTypeId, 'no-display');
		this.addTD(row, buyerType, '');
		this.addTDCbx(row, 'cbx'+buyerTypeId, selected, 'text-center');
			
		tbody.append(row);
	 } 
	table.append(tbody);
  }*/
  
  fillCityCmb =()=>{
		$('#cityCmb').empty();
		$('#cityCmb').prepend($("<option> </option>").val(0).html('City'));
		for(var i=0; i<lstCity.length; i++){
			var cityId 	= lstCity[i].cityId;
			var city  	= lstCity[i].city;
			$('#cityCmb').append($("<option> </option>").val(cityId).html(city)); 
		}
  }
  
  getBuyers =()=> {
		$('#buyerAddForm').trigger('reset');
		$('#factoryName, #address1, #address2, #cityCmb, #factoryPhone').attr('disabled', true);
		this.setState({flg:true})
		$('#generatePassword, #sendApp').hide();

		var companyId = $('#companyCmb').find('option:selected').val();
		if(companyId == 0){
			$('#buyerTableBody tr').remove();
			return false;
		}
		this.setState({loader:'block', opacity:0.5});
	  axiosInstance.get(httpURL+'/a/mst/byr/list',{
		 params:{'parentCompId':companyId}, withCredentials:true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					buyers:response.data.lstBuyer,
				})
				lstBuyers = this.state.buyers;
				this.setBuyerTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'No Buyer exist. Add new'){
					lstBuyers=[];
					this.setBuyerTable();
				}
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  }); 
  }
  
	setBuyerTable =()=> {
		$('#buyerTableBody tr').remove();
		var table 				= document.getElementById('buyerTable');
		var tbody 				= document.getElementById('buyerTableBody');
		var filterBuyerId 		= $('#buyerId').val().trim();
		var filterBuyerName 	= $('#buyerName').val().trim().toLowerCase();
		var filterBuyerEmail 	= $('#buyerEmail').val().trim().toLowerCase();
		var filterBuyer 	    = $('#cbxBuyer').prop('checked') == true ? true : false;
		var filterMerchant 		= $('#cbxMerchant').prop('checked') == true ? true : false;
		var filterFactory 		= $('#cbxFactory').prop('checked') == true ? true : false;
		//var filterBuyerEmail 	= $('#buyerEmail').val().trim().toLowerCase();
		var filterBuyerStatus 	= $('#buyerStatus').find('option:selected').val();
	
		for(var i=0; i<lstBuyers.length; i++){
		var id 				= lstBuyers[i].buyerId+'';
		var name   			= lstBuyers[i].buyer;
		var email   		= lstBuyers[i].eMail;
		var buyer           = lstBuyers[i].flagBuyer;
		var merchant           = lstBuyers[i].flagMerchant;
		var factory           = lstBuyers[i].flagFactory;
		var blocked 		= lstBuyers[i].blocked;
		var blockedStatus 	= blocked === false ? 'Unblocked' : 'Blocked';
		
		var row = document.createElement('tr');
			row.id = id;
		row.onclick =(e)=>{
			$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			$('#generatePassword, #sendApp').show();
			this.setBuyerForm($(e.target).closest('tr').attr('id'));
		}
		
		if(id.indexOf(filterBuyerId) === -1)
			continue;
		if(name.toLowerCase().indexOf(filterBuyerName) === -1)
			continue;
		if(email.toLowerCase().indexOf(filterBuyerEmail) === -1)
			continue;
		if(filterBuyer === true && buyer !== filterBuyer)
			continue;
		if(filterMerchant === true && merchant !== filterMerchant)
		continue;
		if(filterFactory === true && factory !== filterFactory)
		continue;
		
		if(filterBuyerStatus != '' && filterBuyerStatus != blocked)
			continue;
		
		this.addTD(row, id, 'txtright');
		this.addTD(row, name, '');
		this.addTD(row, email, '');
		this.addTDIcon(row, buyer, 'text-center');
		this.addTDIcon(row, merchant, 'text-center');
	
		this.addTD2(row,blockedStatus, 'text-center');
	//	this.addTD(row, blockedStatus, '');
		
		tbody.append(row);
		}
	table.append(tbody);
	}
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		if(val == "blocked"){
			cell.append(text);
		row.append(cell);
			
		}else{
			//cell.style.backgroundColor = '#aaa';
			//span.className = 'glyphicon glyphicon-remove'
			row.append(cell);
			//$('#buyerPOAddForm').show().siblings().hide();
		}
		cell.append(text);
		row.append(cell);
	}

	addTDIcon(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var span = document.createElement('span');
			span.style.fontWeight =  'lighter';
		if(val == true){
			span.className = 'glyphicon glyphicon-ok'
		}else{
			//cell.style.backgroundColor = '#aaa';
			//span.className = 'glyphicon glyphicon-remove'
			row.append(cell);
			//$('#buyerPOAddForm').show().siblings().hide();
		}
		cell.append(span);
		row.append(cell);
		/*var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);*/

	}
	addTD2(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
			
		if(val == "Blocked"){
			cell.append(text);
		row.append(cell);
			
		}else{
			//cell.style.backgroundColor = '#aaa';
			//span.className = 'glyphicon glyphicon-remove'
			row.append(cell);
			//$('#buyerPOAddForm').show().siblings().hide();
		}
		
	}	
	addTDCbx(row, id, flg, classname){  
		var cell = document.createElement('td');
		cell.className = classname;
		var cbx = document.createElement('input');
		cbx.type = 'checkbox';
		cbx.id = id;
		if(flg == 1){
			$(cbx).prop('checked', true);
		}else{
			$(cbx).prop('checked', false);
		}
		cell.append(cbx);
		row.append(cell);
	}
	
	setBuyerForm =(id)=> {
		var buyerData = this.getBuyerData(id);
		this.setState({flg:false});
		if(buyerData !== -1){
			$('#name').val(buyerData.buyer);
			$('#email').val(buyerData.eMail);
			$('#phone').val(buyerData.phoneNo);
			$('#typeBuyer').prop('checked', buyerData.flagBuyer);
			$('#typeMerchant').prop('checked', buyerData.flagMerchant);
			$('#typeFactory').prop('checked', buyerData.flagFactory);
			$('#factoryName').val(buyerData.factory);
			$('#address1').val(buyerData.factoryAddr1);
			$('#address2').val(buyerData.factoryAddr2);
			$('#cityCmb').val(buyerData.factoryCityId);
			$('#factoryPhone').val(buyerData.factoryPhoneNo);
			$("#blocked").prop('checked', buyerData.blocked);
			
			if(buyerData.flagFactory){
				$('#factoryName, #address1, #address2, #cityCmb, #factoryPhone').attr('disabled', false);
			}else{
				$('#factoryName, #address1, #address2, #cityCmb, #factoryPhone').attr('disabled', true);
			}
		}
	}
	
	getBuyerData(id){
		for(var i = 0; i < lstBuyers.length; i++){
			if(id == lstBuyers[i].buyerId){
				return lstBuyers[i];
			}
		}
		return -1;
	}
	
	validateEmail(x){
		var atpos = x.indexOf("@");
		var dotpos = x.lastIndexOf(".");
		if (atpos<1 || dotpos<atpos+2 || dotpos+2>=x.length) {
			return false;
		}else{
			return true;
		}
	}
	
	addBuyerReady =()=>{
		var companyId 	= $('#companyCmb').find('option:selected').val();
		if(companyId == 0){
			toast.warning('Please select company');
			return false;
		}
		$('#buyerAddForm').trigger('reset');
		$('#factoryName, #address1, #address2, #cityCmb, #factoryPhone').attr('disabled', true);
		this.setState({flg:true})
		$('#generatePassword, #sendApp').hide();
	}
	
	maintainBuyer =()=>{
		if(this.state.flg){
			this.addBuyer();
		}else{
			this.editBuyer();
		}
	}
	
	addBuyer(){
		var buyer 		= {};
		var companyId 	= $('#companyCmb').find('option:selected').val();
		var name 		= $('#name').val();
		var email 		= $('#email').val();
		var phone		= $('#phone').val();
		var typeBuyer	= $('#typeBuyer').prop('checked') ? true : false;
		var typeMerchant= $('#typeMerchant').prop('checked') ? true : false;
		var typeFactory	= $('#typeFactory').prop('checked') ? true : false;
		var factoryName = $('#factoryName').val();
	
	
		var blocked 	= $('#blocked').prop('checked') ? true : false;
	
		if(companyId == 0){
			toast.warning('Please select company');
			return false;
		}
		if(name == ''){
			toast.warning('Please fill buyer name');
			document.getElementById('name').focus();
			return false;
		}
		if(email == ''){
			toast.warning('Please fill buyer E-Mail');
			document.getElementById('email').focus();
			return false;
		}else{
			var result = this.validateEmail(email);
			if(result==false){
				toast.warning("Invalid Email");
				document.getElementById("email").focus();
				return false;
			}
		}
	
		if(phone == ''){
			toast.warning('Please fill phone');
			document.getElementById('phone').focus();
			return false;
		}
	
		if(phone.length != 10){
			toast.warning('Phone number should be 10 digits only');
			document.getElementById('phone').focus();
			return false;
		}
	
		if(isNaN(phone)){
			toast.warning('Phone number should be numeric');
			document.getElementById('phone').focus();
			return false;
		}
		
		if(typeBuyer == 0 && typeMerchant == 0 && typeFactory == 0){
			toast.warning('Please select one buyer type');
			return false;
		}
		
	
	
	
		buyer={'parentCompId':companyId, 'buyerId':0, 'buyer':name, 'eMail':email, 'phoneNo': phone,  'flagBuyer':typeBuyer, 'flagMerchant':typeMerchant, 'blocked':blocked}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/byr/save', 
			queryString.stringify({'buyer':JSON.stringify(buyer)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				buyer.buyerId = response.data.buyerId;
				lstBuyers.push(buyer);
				this.setBuyerTable();
				this.setBuyerForm(response.data.buyerId);
				this.highlightRow('buyerTableBody', response.data.buyerId);
				this.setState({flg : false})
				$('#generatePassword, #sendApp').show();
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	editBuyer(){
		var buyer 		= {};
		var lstBuyerType= [];
		var buyerId 	= $('#buyerTableBody tr.selected').find(buyerIdCol).text();
		var companyId 	= $('#companyCmb').find('option:selected').val();
		var name 		= $('#name').val();
		var email 		= $('#email').val();
		var phone		= $('#phone').val();
		var typeBuyer	= $('#typeBuyer').prop('checked') ? true : false;
		var typeMerchant= $('#typeMerchant').prop('checked') ? true : false;
	
		var blocked 	= $('#blocked').prop('checked') ? true : false;
	
		if(companyId == 0){
			toast.warning('Please select company');
			return false;
		}
		if(name == ''){
			toast.warning('Please fill buyer name');
			document.getElementById('name').focus();
			return false;
		}
		if(email == ''){
			toast.warning('Please fill buyer E-Mail');
			document.getElementById('email').focus();
			return false;
		}else{
			var result = this.validateEmail(email);
			if(result==false){
				toast.warning("Invalid Email");
				document.getElementById("email").focus();
				return false;
			}
		}
	
		if(phone == ''){
			toast.warning('Please fill phone');
			document.getElementById('phone').focus();
			return false;
		}
		
		if(phone.length != 10){
			toast.warning('Phone number should be 10 digits only');
			document.getElementById('phone').focus();
			return false;
		}
	
		if(isNaN(phone)){
			toast.warning('Phone number should be numeric');
			document.getElementById('phone').focus();
			return false;
		}
		
		if(typeBuyer == 0 && typeMerchant == 0){
			toast.warning('Please select one buyer type');
			return false;
		}
		
	
	
		buyer={'parentCompId':companyId, 'buyerId':buyerId, 'buyer':name, 'eMail':email, 'phoneNo': phone, 'flagBuyer':typeBuyer, 'flagMerchant':typeMerchant, 'blocked':blocked}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/byr/save', 
			queryString.stringify({'buyer':JSON.stringify(buyer)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				var buyerIdx = this.getIdxBuyer(buyerId);
				lstBuyers.splice(buyerIdx,1,buyer);
				this.setBuyerForm(buyerId);
				this.setBuyerTable();
				this.highlightRow('buyerTableBody', buyerId);
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	getIdxBuyer(buyerId){
		for(var i=0; i<lstBuyers.length; i++){
			if(lstBuyers[i].buyerId == buyerId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var buyerId = $(this).find(buyerIdCol).text();
			if(buyerId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	generateBuyerPwd(){
		var buyerId 	= $('#buyerTableBody tr.selected').find(buyerIdCol).text();
		var emailId 	= $('#buyerTableBody tr.selected').find(buyerEmailCol).text();
		if(buyerId == ''){
		  toast.warning('Please select buyer');
			return false; 
		}
		//this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/byr/generatepassword',
			queryString.stringify({'buyerId':buyerId, 'emailId':emailId}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			//this.setState({loader:'none', opacity:1});
 	  }).catch((e)=>{
	           toast.error("Service failed "+e);
  	});
	}
	
	checkFactory=(e)=>{
		if($(e.target).prop('checked') == true){
			$('#factoryName, #address1, #address2, #cityCmb, #factoryPhone').attr('disabled', false);
		}else{
			if($('#factoryName').val() == ''){
				$('#factoryName, #address1, #address2, #cityCmb, #factoryPhone').attr('disabled', true);
			}else{
				var x = window.confirm('Disabling this will clear all the factory details');
				if(x){
					$('#factoryName').val('');
					$('#address1').val('');
					$('#address2').val('');
					$('#cityCmb').val(0);
					$('#factoryPhone').val('');
					$('#factoryName, #address1, #address2, #cityCmb, #factoryPhone').attr('disabled', true);
				}else{
					e.preventDefault();
				}
			}
		}
	}

  render() {
	httpURL = window.httpURL;  
    return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-12 col-centered">
						<div style={{marginBottom:10}}>
							<select onChange={this.getBuyers} className="select-box" id="companyCmb"></select>
						</div>
						<div className="col-sm-7 col-xs-11 padding-remove">
							<table className="tableLayout1" style={{width:this.state.width}}>
								<thead>
									<tr>
										<th style={{width:30}}>
											<input onChange={this.setBuyerTable} type="text" className="form-control inp-search" id="buyerId" placeholder="Id" />
										</th>
										<th style={{width:100}}>
											<input onChange={this.setBuyerTable} type="text" className="form-control inp-search" id="buyerName" placeholder="Buyer Name" />
										</th>
										<th style={{width:155}}>
											<input onChange={this.setBuyerTable} type="text" className="form-control inp-search" id="buyerEmail" placeholder="E-Mail" />
										</th>
										<th style={{width:50, position:'relative', textAlign:'left'}}>
											Buyer
											<input style={{position:'absolute', top:6, right:2}} onChange={this.setBuyerTable} type="checkbox" id="cbxBuyer" />
										</th>
										<th style={{width:70, position:'relative', textAlign:'left'}}>
											Merchant
											<input style={{position:'absolute', top:6, right:2}} onChange={this.setBuyerTable} type="checkbox" id="cbxMerchant" />
										</th>
										
										<th style={{width:60}}>
											<select onChange={this.setBuyerTable} className="form-control inp-select" id="buyerStatus">
												<option value=''>Status</option>
												<option value='1'>Blocked</option>
												<option value='0'>Unblocked</option>
											</select>
										</th>
									</tr>
								</thead>
							</table>
							<div className="buyerTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="buyerTable" className="tableLayout">
									<colgroup>
										<col width="30" />
										<col width="100" />
										<col width="155" />
										<col width="50" />
										<col width="70" />
										
										<col width="60" />
									</colgroup>
									<tbody id="buyerTableBody">
									</tbody>
								</table>
							</div>
						</div>
						<div className="col-sm-1 col-xs-1">
							<span id="addBuyer" title="Add Buyer" onClick={this.addBuyerReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-4 col-xs-12">
							<form id="buyerAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Buyer Name:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Buyer Name" id="name"/>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-5">Buyer E-Mail:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Buyer E-Mail" id="email"/>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-5">Buyer Phone:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" maxLength="10" className="form-control" placeholder="Buyer Phone" id="phone"/>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-5">Buyer Type:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<div>
											<label className="control-label col-sm-5">Buyer:</label>
											<div className="col-sm-7">
												<div className="checkbox" style={{paddingTop:0}}>
													<input type="checkbox" id="typeBuyer"/>
												</div>
											</div>
										</div>
										<div>
											<label className="control-label col-sm-5">Merchant:</label>
											<div className="col-sm-7">
												<div className="checkbox" style={{paddingTop:0}}>
													<input type="checkbox" id="typeMerchant"/>
												</div>
											</div>
										</div>
										
									</div>
								</div>
							
								<div className="form-group">
									<label className="control-label col-sm-5">Blocked:</label>
									<div className="col-sm-7">
										<div className="checkbox" style={{paddingTop:0}}>
											<input type="checkbox" id="blocked"/>
										</div>
									</div>
								</div>
								<div className="form-group" style={{marginTop:20}}>
								<div className="col-sm-12 text-center">
									<button type="button" onClick={this.maintainBuyer} className="btn btn-warning">Save</button>
									<button style={{marginLeft:10, display:'none'}} id="generatePassword" onClick={this.generateBuyerPwd} type="button" className="btn btn-warning">Generate Password</button>
									<button style={{marginLeft:10, display:'none'}} id="sendApp" type="button" className="btn btn-warning">Send App</button>
								</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default MaintainBuyers;
